import { useEffect, useState } from 'react';

type WindowSizeTypes = {
  height?: number;
  width?: number;
};

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<WindowSizeTypes>({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export { useWindowSize };
